import * as Yup from 'yup';
import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../common/SnackbarAlert';
import React from 'react';
function CreateEdit({
  closeCreateEditForm,
  vehichleMakeEditDatas,
  editStatus,
  setNewValue=null
}) {
  const regExp = /^(\d+(?:[\.\,]\d{2})?)$/;

  const VehichleTypeSchema = Yup.object().shape({
    name: Yup.string()
      .required('Vehicle Make Name is required')
      // .min(3, 'Vehicle Make Name must be at least 3 character')
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Vehicle Name only accepts special characters like &,[,],-,/,(,)'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Vehicle Name must include at least one letter of the alphabet'
      // )
      .test(
        'no-leading-space',
        'Cannot start with a space',
        (value) => !value || value.trimStart() === value
      ),
    code: Yup.string()
      .required('Vehicle Make Code is required')

  });

  const cancelClickedFlag = useRef(false);
  const [loader, setLoader] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      name: '',
      code: '',
      status: true
    },
    validationSchema: VehichleTypeSchema,
    onSubmit: (values) => {
      values.name = String(values.name);
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      const url = editStatus ? 'vehichle/vehicleMake/'+values.id : 'vehichle/createVehicleMake'
      request({
        url: url,
        method: method,
        data: values
      })
        .then((vehichleType) => {
          if (vehichleType.status) {
            if (setNewValue) {
              setNewValue(values?.name);
            }
            closeCreateEditForm(true);
            setLoader(false);
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: vehichleType['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = vehichleMakeEditDatas.id;
    formik.initialValues.name = vehichleMakeEditDatas.name;

    formik.initialValues.code = vehichleMakeEditDatas.code;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const handleCancelMouseDown = () => {
    cancelClickedFlag.current = true;
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} className='ListContainer'>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Vehicle Make" />
              ) : (
                <CardHeader title="Create Vehicle Make" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Name{' '}
                            <Typography
                              component="span"
                              sx={{ color: 'red' }}
                            >
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="name"
                        value={capitalizeFirst(formik.values.name)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.name &&
                          Boolean(formik.errors.name)
                        }
                        helperText={
                          formik.touched.name &&
                          formik.errors.name
                        }
                      />
                    </Grid>


                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Code{' '}
                            <Typography
                              component="span"
                              sx={{ color: 'red' }}
                            >
                              *
                            </Typography>
                          </React.Fragment>
                        }

                        sx={{ width: '100%' }}
                        size="small"
                        type="string"
                        name="code"
                        value={formik.values.code}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.code &&
                          Boolean(formik.errors.code)
                        }
                        helperText={
                          formik.touched.code &&
                          formik.errors.code
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                        onMouseDown={handleCancelMouseDown}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default CreateEdit;
